import { motion } from 'framer-motion'
import { useEffect, useMemo, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import SpotifyLogo from '../assets/images/spotify-logo.svg'
import { useLanyardWS } from '../util/useLanyardWS'

const discordId = '819191621676695563'

function Doing() {
  const data = useLanyardWS(discordId)
  const [doing, setDoing] = useState(data)
  const [time, setTime] = useState('')
  useEffect(() => {
    setDoing(data)
  }, [data])

  const currentActivity = useMemo(
    () => doing?.activities?.find(activity => activity.type === 0),
    [doing],
  )
  useEffect(() => {
    if (
      currentActivity
      && currentActivity.timestamps
      && currentActivity.timestamps.start
    ) {
      const startDate = new Date(currentActivity.timestamps.start)
      const now = new Date()
      const elapsedTimeInSeconds = Math.floor((now - startDate) / 1000)

      if (elapsedTimeInSeconds < 60) {
        setTime(`just started playing`)
      }
      else if (elapsedTimeInSeconds < 3600) {
        const minutes = Math.floor(elapsedTimeInSeconds / 60)
        setTime(`For ${minutes} minutes`)
      }
      else {
        const hours = Math.floor(elapsedTimeInSeconds / 3600)
        setTime(`For ${hours} hours`)
      }
    }
    else {
      setTime('')
    }
  }, [currentActivity])

  const conditions = [
    {
      condition: currentActivity?.name === 'Genshin Impact',
      imageUrl:
        'https://res.cloudinary.com/ddcjzcoys/image/upload/v1710622782/bkag6dfiqobbljqrsvug.png',
      state: time,
    },
  ]
  return (
    <>
      {doing?.listening_to_spotify
        ? (
            <Container
              onClick={() =>
                window.open(
                  `https://open.spotify.com/track/${doing?.spotify?.track_id}`,
                )}
            >
              <h5>
                Listening to Spotify
                {' '}
                <LiveDot />
              </h5>
              <>
                <ActivityRow>
                  <ActivityImageContainer>
                    <ActivityImage
                      src={doing.spotify.album_art_url}
                      alt={doing.spotify.song}
                    />
                    <ActivitySecondaryImage
                      src={SpotifyLogo}
                      alt="spotify"
                    />
                  </ActivityImageContainer>

                  <ActivityInfo>
                    <h5>{doing.spotify.song}</h5>
                    <p>
                      by
                      {doing.spotify.artist}
                    </p>
                  </ActivityInfo>
                </ActivityRow>
              </>
            </Container>
          )
        : null}
      {currentActivity ? (
        <Container to="/">
          <h5>Doing something</h5>
          <ActivityRow>
            {currentActivity.assets
              ? (
                  <ActivityImageContainer>
                    <ActivityImage
                      src={`https://cdn.discordapp.com/app-assets/${currentActivity.application_id}/${currentActivity.assets.large_image}.png`}
                      alt="Activity Image"
                      onError={e =>
                        (e.target.src = `https://media.discordapp.net/${currentActivity?.assets?.large_image.replace(
                          'mp:',
                          '',
                        )}`)}
                    />
                  </ActivityImageContainer>
                )
              : currentActivity.assets?.small_image
                ? (
                    <ActivityImageContainer>
                      <ActivitySecondaryImage
                        src={`https://cdn.discordapp.com/app-assets/${currentActivity.application_id}/${currentActivity.assets.small_image}.png`}
                        onError={e =>
                          (e.target.src = `https://media.discordapp.net/${currentActivity?.assets?.small_image.replace(
                            'mp:',
                            '',
                          )}`)}
                      />
                    </ActivityImageContainer>
                  )
                : null}

            {/* fun logic */}
            {conditions.map(
              (imageData, index) =>
                imageData.condition && (

                  <ActivityImageContainer key={index}>
                    <ActivityImage src={imageData.imageUrl} />
                  </ActivityImageContainer>

                ),
            )}
            {/* default */}
            <ActivityInfo>
              <h5>{currentActivity.name}</h5>
              {conditions.map((conditionData, index) =>
                conditionData.condition
                  ? (
                      <p key={index}>{conditionData.details}</p>
                    )
                  : null,
              )}
              {conditions.map((conditionData, index) =>
                conditionData.condition
                  ? (
                      <p key={index}>{conditionData.state}</p>
                    )
                  : null,
              )}
              {currentActivity.details
                ? (
                    <p>{currentActivity.details}</p>
                  )
                : null}
              {currentActivity.state ? <p>{currentActivity.state}</p> : null}
            </ActivityInfo>
          </ActivityRow>
        </Container>
      ) : null}
    </>
  )
}

const Container = styled(motion.div)`
  width: calc(100% + 2rem);
  margin-left: -2rem;
  background-color: transparent;
  color: #ccc;
  border-top: 1px solid hsl(var(--primary-800));
  padding: 1rem;
  cursor: pointer;

  &:hover {
    background-color: hsl(var(--primary-800));
    color: #fff;
  }

  h5 {
    margin: 0;
    margin-bottom: 10px;
  }
`

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0%;
  }
`

const LiveDot = styled.div`
  display: inline-block;
  margin-left: 4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff5252;
  animation: ${fadeInOut} 2s ease-in-out infinite;
`

const ActivityRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const ActivityImageContainer = styled.div`
  position: relative;
  height: 50px;
`

const ActivityImage = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 10px;
  object-fit: cover;
  object-position: top;
`
const ActivitySecondaryImage = styled.img`
  position: absolute;
  bottom: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: hsl(var(--primary-900));
  border: 2px solid hsl(var(--primary-900));
`

const ActivityInfo = styled.div`
  margin-left: 1rem;

  h5 {
    color: #fff;
    margin: 0;
  }

  p {
    margin: 0;
    font-size: 0.8rem;
  }
`
export default Doing
